import Theme8 from "./theme8"
import Theme13 from "./theme13"

export function LoginSection(props) {
    const { theme } = props
    switch (theme) {
        case 'theme8':
            return <Theme8 {...props} />
        case 'theme13':
            return <Theme13 {...props} />
        
        default:
            return <Theme8 {...props} />
    }
}

export default LoginSection;